import { render } from "./CerrarCaja.vue?vue&type=template&id=96ff056e"
import script from "./CerrarCaja.vue?vue&type=script&lang=js"
export * from "./CerrarCaja.vue?vue&type=script&lang=js"

import "./CerrarCaja.vue?vue&type=style&index=0&id=96ff056e&lang=css"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__